import { c as _c } from "react/compiler-runtime";
import './initials-avatar.scss';
import React from 'react';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
const iconSize = {
  sm: '16px',
  md: '24px',
  lg: '32px'
};
export const InitialsAvatar = t0 => {
  const $ = _c(13);
  const {
    size: t1,
    initials,
    notificationCount
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const t2 = size === "sm";
  const t3 = size === "md";
  const t4 = size === "lg";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = cn("InitialsAvatar flex flex-col items-center justify-center relative text-center", {
      "InitialsAvatar--sm label-md label-potent": t2,
      "InitialsAvatar--md label-xl label-potent": t3,
      "InitialsAvatar--lg heading-sm label-potent": t4
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== initials || $[5] !== size) {
    t6 = initials ?? <ArkIcon iconName="user-01" size={iconSize[size]} />;
    $[4] = initials;
    $[5] = size;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== notificationCount) {
    t7 = !!notificationCount && <span className="InitialsAvatar__notificationCount absolute label-sm label-potent">{notificationCount}</span>;
    $[7] = notificationCount;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6 || $[11] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};